let DEV_API_ENDPOINT = 'https://cqdvrc0awa.execute-api.ap-south-1.amazonaws.com/stg/';
let PROD_API_ENDPOINT = 'https://s9esltpwug.execute-api.ap-south-1.amazonaws.com/prod/';
export default {
    production: {
        api: process.env.REACT_APP_API_ENVIRONMENT === 'production'? PROD_API_ENDPOINT : DEV_API_ENDPOINT
    }
}